import React from 'react';
import { Link } from 'react-router-dom';
import { Crown, ArrowRight } from 'lucide-react';
import { useMember, hasTier } from './MemberAuthContext';

/*
 * HomeSolutionsGate — friendly upsell shown when a non-Premium+ visitor
 * tries to open a Home Solutions service. Signed-out visitors are
 * pointed at Join Free; paid non-Premium members see the upgrade path.
 *
 *   <HomeSolutionsGate open={open} onClose={() => setOpen(false)} />
 */
const HomeSolutionsGate = ({ open, onClose }) => {
  const { member } = useMember();
  if (!open) return null;

  const isSignedIn = member && member.tier;
  const canAccess = hasTier(member, 'PREMIUM_PLUS');
  if (canAccess) return null; // Premium+ members bypass the gate

  return (
    <div className="access-gate" role="dialog" aria-modal="true" aria-labelledby="hs-gate-title" data-testid="home-solutions-gate">
      <div className="access-gate-card">
        <span className="access-gate-eyebrow">HOME SOLUTIONS</span>
        <h2 id="hs-gate-title" className="access-gate-title">
          <Crown size={18} strokeWidth={2} aria-hidden="true" style={{ verticalAlign: '-3px', marginRight: '0.35rem' }} />
          Available on Premium+
        </h2>
        <p className="access-gate-body">
          N3URO Home Solutions is exclusive to active Premium+ members. Upgrade
          any time and unlock the full pathway &mdash; from Discovery through
          Space Review, Concept, Detailed Scope and Build. Family+ and Access+
          keep the Home-Space digital toolkit, but Home Solutions commissions
          require Premium+.
        </p>
        <div className="access-gate-actions">
          {isSignedIn ? (
            <Link to="/access/account" className="access-gate-primary" data-testid="hs-gate-upgrade" onClick={onClose}>
              Upgrade to Premium+ <ArrowRight size={14} strokeWidth={2.5} />
            </Link>
          ) : (
            <Link to="/access/join" className="access-gate-primary" data-testid="hs-gate-join" onClick={onClose}>
              Join Free, then upgrade <ArrowRight size={14} strokeWidth={2.5} />
            </Link>
          )}
          <a
            href="mailto:hello@n3uro.world?subject=Home%20Solutions%20enquiry"
            className="access-btn-ghost"
            data-testid="hs-gate-talk"
          >
            Talk to us about Home Solutions
          </a>
          <button type="button" className="access-gate-close" onClick={onClose} data-testid="hs-gate-close">
            Not now
          </button>
        </div>
      </div>
    </div>
  );
};

export default HomeSolutionsGate;
